import React from 'react';
import { Link } from 'react-router-dom';
import { getAllPosts } from '../utils';

const formatDate = (dateString: string) => {
  try {
    const [year, month, day] = dateString.split('-').map((num) => parseInt(num, 10));
    const date = new Date(Date.UTC(year, month - 1, day));

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch (e) {
    console.error('Error parsing date:', dateString);
    return 'Invalid date';
  }
};

function BlogListPage() {
  const posts = getAllPosts().sort((a, b) => {
    const dateA = new Date(a.frontmatter.date);
    const dateB = new Date(b.frontmatter.date);
    return dateB.getTime() - dateA.getTime();
  });

  return (
    <div className="max-w-4xl mx-auto px-4 py-6 sm:py-8">
      <div className="mb-10 text-center sm:text-left">
        <div className="inline-flex items-center gap-3 rounded-full border border-white/45 bg-gradient-to-r from-white/25 to-sky-200/20 px-5 py-2.5 backdrop-blur-md shadow-[inset_0_1px_0_rgba(255,255,255,0.5),0_8px_28px_rgba(0,80,140,0.2)]">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/40 bg-gradient-to-b from-white/50 to-sky-300/30 shadow-aero-bubble" aria-hidden>
            <svg className="h-5 w-5 text-sky-800/90" fill="currentColor" viewBox="0 0 24 24">
              <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z" />
            </svg>
          </span>
          <div>
            <h1 className="font-display text-3xl sm:text-4xl font-semibold aero-title-gradient-dark">
              Blog Posts
            </h1>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {posts.map((post) => (
          <div
            key={post.slug}
            className="glass-card group rounded-[1.35rem] overflow-hidden hover:scale-[1.01] transition-all duration-300 ring-1 ring-slate-300/35 hover:ring-sky-400/50"
          >
            <div className="absolute left-0 top-0 h-full w-1.5 bg-gradient-to-b from-white/80 via-sky-200/90 to-cyan-400/70 opacity-90" aria-hidden />
            <div className="p-6 pl-8">
              <h2 className="text-2xl font-display font-medium text-slate-900 mb-2">
                <Link
                  to={`/blog/${post.slug}`}
                  className="hover:text-sky-700 transition-colors duration-200"
                >
                  {post.frontmatter.title}
                </Link>
              </h2>
              <p className="text-slate-700 mb-4 leading-relaxed">{post.frontmatter.excerpt}</p>
              <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-between sm:items-center">
                <span className="text-sm text-slate-600 font-light">
                  {formatDate(post.frontmatter.date)}
                </span>
                <Link
                  to={`/blog/${post.slug}`}
                  className="glass-button self-start sm:self-auto px-5 py-2.5 rounded-full text-white text-sm font-display font-medium"
                >
                  Read more →
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BlogListPage;
